<template>
  <div id="home">
    <div class="Contenedor debugear">
      <Menu areWeinHome="true"/>
      <SlideShowComponent/>
      <ServicesComponent/>
      <WhoweareComponent/>
      <!-- <SubscribeComponent/> -->
      <FooterComponent/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Menu from "@/components/Menu2.vue";

import SlideShowComponent from "@/components/SlideShow.vue";
import WhoweareComponent  from "@/components/Whoweare.vue";
import ServicesComponent  from "@/components/Services.vue";
import SubscribeComponent from "@/components/Subscribe.vue";
import FooterComponent    from "@/components/Footer.vue";

export default {
  name: "app",
  data: function() {
    return {
      keycode: "",
      showclass: false
    };
  },
  components: {
    Menu,
    SlideShowComponent,
    WhoweareComponent,
    ServicesComponent,
    SubscribeComponent,
    FooterComponent
  },

  mounted() {
    this.$nextTick(() => {
      // Menu-toggle button
      document.title = "We keep your people safe in Mexico"
    });
  },
  methods: {
    handleEnter: function() {
      //console.log("se ha hecho click en enter");
      this.showclass = !this.showclass;
    }
  }
};
</script>

<style lang="less">
@import url("../assets/less/soloVariables.less");
</style>
